import { rootApi } from '../rootApi';
export const dealerAddressUsersApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getDealerAddressUsers: builder.query({
            query: ({ AddressId, PageNumber = 1, PageSize = 10 }) => ({
                url: '/v1/dealeraddressusers/getdealeraddressusers',
                method: 'GET',
                params: {
                    AddressId,
                    PageNumber,
                    PageSize
                }
            }),
            transformResponse: (response) => ({
                count: response.data.totalCount,
                items: response.data.items
            })
        })
    })
});

export const { useGetDealerAddressUsersQuery } = dealerAddressUsersApi;
